import { styled } from '@mui/system';
import { TableRow, TableCell } from '@mui/material';

export const StyledEmptyRow = styled(TableRow)(() => ({
  textAlign: 'center',
  height: '400px',
}));

export const StyledEmptyCell = styled(TableCell)(() => ({
  background: 'trasparent',
  textAlign: 'center',
}));
